export default "__VITE_ASSET__DRHv02y6__"